<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <b-container>
      <section class="section--saved_selection" id="scrollToOnLoad">
        <h2 class="text-center">List of students
          <span class="text--shadow-center">List of students</span>
        </h2>
        <p class="text-center text--small mb-5">The list of students and their experiments</p>
        <div v-for="(student, index) in studentsList" :key="index">
          <list-of-students :student="student"></list-of-students>
        </div>
        <b-pagination v-if="totalRows > perPage" size="md"
          :total-rows="totalRows" :per-page="perPage">
        </b-pagination>
      </section>
    </b-container>
    <section-support></section-support>
  </main>
</template>

<script>
import teacher from '@/api/v1/teacher';
import Hero from '@/components/Hero';
import Support from '@/components/Support/Index';
import ListOfStudents from '@/views/Game/ListOfStudents/ListOfStudents';

export default {
  components: {
    'section-hero': Hero,
    'section-support': Support,
    ListOfStudents,
  },
  data() {
    return {
      bgImg: 'Banner2-Experiment-',
      subtitle: this.$t('nav.experiment'),
      studentsList: [],
      perPage: 10,
    };
  },
  computed: {
    totalRows() {
      return this.studentsList.length;
    },
  },
  methods: {
    getListOfStudents() {
      const succ = (response) => { this.studentsList = response.data.students; };
      teacher.list(succ);
    },
  },
  created() {
    this.getListOfStudents();
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";
.section {
  &--saved_selection {
    padding: 130px 0 100px;
  }
}
.experiments {
  padding: 0 0 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/Game/ListOfStudents/Index.vue